<template>
  <v-card elevation="0">
    <v-card-title>Параметры подключения к кассовому серверу r_keeper</v-card-title>
    <v-card-text>
      <v-row class="d-flex" dense>
        <v-col class="col-6">
          <v-text-field
            v-model="rk7Config.host"
            label="Адрес кассового сервера"
          ></v-text-field>
        </v-col>
        <v-col class="col-6">
          <v-text-field
            v-model="rk7Config.port"
            label="Порт для подключения к xml-интерфейсу кассового сервера"
            :rules="[rules.port]"
          ></v-text-field>
        </v-col>
        <v-col class="col-6">
          <v-text-field
            v-model="rk7Config.user"
            label="Логин пользователя"
          ></v-text-field>
        </v-col>
        <v-col class="col-6">
          <v-text-field
            type="password"
            v-model="rk7Config.password"
            label="Пароль пользователя"
          ></v-text-field>
        </v-col>
        <v-col class="col-6">
          <v-switch
            v-model="rk7Config.use_saas"
            label="Использовать SaaS XML для подключения к rk7"
          ></v-switch>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  props: ["rk7Config"],
  methods: {
  },
  computed: {
    rules() {
      return {
        port: v => (/^\d+$/.test(v)) && (v >= 0) && (v <= 65535) || 'Значение должно быть от 0 до 65535'
      }
    }
  }
};
</script>

<style>
</style>